import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RefundFlowEndPoints} from 'main/factories/usecases';
import {PostCreateProtocol} from 'domain/usecases';
import {RemotePostCreateProtocol} from 'data/usecases';

export const makePostCreateProtocol = (): PostCreateProtocol =>
	new RemotePostCreateProtocol(
		makeBFFApiUrl(RefundFlowEndPoints.additionalDocumentsCreate),
		makeAuthorizeHttpClientDecorator(),
	);
